import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/PublicPages.css';

const DeleteAccount = () => (
    <div className="public-page">
        <header className="public-header">
            <Link to="/" className="public-brand">
                <img src="/GTS.png" alt="GTS Portal" />
                <span>GTS Portal</span>
            </Link>
            <Link to="/login" className="public-header-link">Sign in</Link>
        </header>

        <main className="public-content public-content-narrow">
            <p className="public-eyebrow">GTS Portal</p>
            <h1>Request account deletion</h1>
            <p className="public-updated">For employees and other GTS Portal account holders</p>

            <p>
                You can request deletion of your GTS Portal account and associated personal
                information through your organization&apos;s HR team or portal administrator.
            </p>

            <h2>How to submit a request</h2>
            <ol>
                <li>Contact your organization&apos;s HR team or portal administrator through the official company channel.</li>
                <li>Ask for your GTS Portal account deletion request to be submitted.</li>
                <li>Include the email address or employee ID associated with your account so your identity can be verified.</li>
            </ol>

            <h2>What happens next</h2>
            <p>
                The organization administrator will verify the request and disable the account.
                Personal account information will be deleted or anonymized where it is no longer
                required. Some records, including payroll, attendance, expenses, documents,
                messages, approvals and audit records, may be retained when required for legal,
                accounting, security or legitimate business purposes. Retained records will not
                be used to keep the deleted account active.
            </p>

            <h2>Need help?</h2>
            <p>
                If you cannot reach your HR team or administrator, use the contact method your
                organization provided for GTS Portal support. Do not send passwords or other
                sensitive credentials with a deletion request.
            </p>

            <p className="public-callout">
                This request process applies to employee, manager, HR, administrator, accounts
                and team-lead accounts alike.
            </p>
        </main>

        <footer className="public-footer">
            <span>GTS Portal — internal use only</span>
            <nav aria-label="Legal links">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/delete-account">Delete Account</Link>
                <Link to="/">Home</Link>
            </nav>
        </footer>
    </div>
);

export default DeleteAccount;
